import { CardTextRuleType } from "../models/CardRuleEngine";
import { CardVariant } from "../models/CardVariant";

const hasDamageXAbilityRegex = /damage [0-9]/gmi;
const isCrystalGeneratorRegex = /gain {crystalicon}|gain{crystalicon}/gmi;

export const CARD_TEXT_RULES: Record<CardTextRuleType, (variant: CardVariant) => boolean> = {
    hasDamageXAbility: (variant: CardVariant) => {
        if (!hasAbilityText(variant)) {
            return false;
        }

        return hasDamageXAbilityRegex.test(variant.card.normalizedEffectText!);
    },
    isCrystalGenerator: (variant: CardVariant) => {
        if (!hasAbilityText(variant)) {
            return false;
        }

        return isCrystalGeneratorRegex.test(variant.card.normalizedEffectText!);
    },
    isMultiElement: (variant: CardVariant) => {
        return variant.card.elements.length > 1;
    }
}

function hasAbilityText(variant: CardVariant) {
    return variant && variant?.card && variant?.card?.normalizedEffectText;
}